import { Routes, Route } from "react-router-dom";

import Nav from "./components/nav/Nav";
import HomePage from "./pages/HomePage";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Register from "./pages/Register";
import Login from "./pages/Login";
import UserProfile from "./pages/UserProfile";
import Cart from "./pages/Cart";
import Footer from "./components/Footer";
import OrderList from "./pages/OrderList";
import OrderDetail from "./pages/OrderDetail";

import "./App.css";

function App() {
  return (
    <div className="App">
      <Nav />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:id" element={<ProductDetail />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/my-profile" element={<UserProfile />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/my-orders" element={<OrderList />} />
        <Route path="/my-orders/:id" element={<OrderDetail />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
